'use client'
// This file is a simple re-export to avoid circular dependencies
import React from 'react'
import dynamic from 'next/dynamic'
import { FormBlockType } from './types'
import { FormSkeleton } from './FormSkeleton'
import { PopUpSkeleton } from './PopUpSkeleton'

// Define the FormBlock component directly here to avoid circular dependencies
export const FormBlock: React.FC<
  {
    id?: string
    formKey?: React.Key
    useFormSkeleton?: boolean
  } & FormBlockType
> = (props) => {
  const { useFormSkeleton = false } = props
  // We're using dynamic import to break the circular dependency
  const FormBlockDynamic = dynamic(
    () =>
      import('@/ui/blocks/Form/FormBlockComponent').then((mod) => ({
        default: mod.FormBlockComponent,
      })),
    {
      ssr: false,
      loading: () => (useFormSkeleton ? <FormSkeleton /> : <PopUpSkeleton />),
    },
  )

  return <FormBlockDynamic {...props} />
}

// Re-export the types
export type { FormBlockType, Data, Value, Property } from './types'
